import { ProjectLiteViewModel } from '@/business/project/interfaces/project-lite-view-model'
import { EmptyProject, ProjectViewModel } from '@/business/project/interfaces/project-view-model'

export interface ProjectState {
  project: ProjectViewModel
  projects: ProjectLiteViewModel[]
}

export function emptyProjectState(): ProjectState {
  return {
    project: EmptyProject,
    projects: [],
  }
}
